var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfElementLol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 273,
    viewBox: "0 0 256 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_9)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_465_9",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 273
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.9 0H0V272.96H255.9V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_465_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.41 83.1699C5.59 100.97 0 121.36 0 143.03C0 164.7 5.59 185.11 15.41 202.92V83.1699Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.95 17.25C117.57 17.25 107.5 18.5 97.8301 20.79V40.58C107.4 37.88 117.49 36.41 127.95 36.41C187.85 36.41 236.41 83.99 236.41 142.72C236.41 169.16 226.54 193.35 210.24 211.94L207.15 222.8L200.29 246.81C233.88 224.15 255.92 186.14 255.92 143.07C255.9 73.58 198.61 17.26 127.95 17.26V17.25Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8303 208.31H198.11C214.72 191.24 224.94 168.15 224.94 142.71C224.94 90.2001 181.51 47.6401 127.94 47.6401C117.42 47.6401 107.31 49.3101 97.8203 52.3401V208.32L97.8303 208.31Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2297 0H13.2197L27.0097 28.14V244.84L13.2197 272.96H180.78L195.96 219.72H86.2297V0Z",
    fill: "#737373"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255.9,
    height: 272.96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfElementLol);
export default __webpack_public_path__ + "static/media/inf-element-LOL.e01b4be16de30c5e8763d1bc9a06b03b.svg";
export { ForwardRef as ReactComponent };